import { render, staticRenderFns } from "./IcoTag.vue?vue&type=template&id=3e6e567f"
import script from "./IcoTag.vue?vue&type=script&lang=js"
export * from "./IcoTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports